<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <IncomingSalesLeadsTable />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IncomingSalesLeadsTable from "./tables/incomingSalesLeadsTable.vue";

export default {
    components: { IncomingSalesLeadsTable },
    data: () => ({}),
    computed: {},
    methods: {},
    mounted() {},
};
</script>

<style></style>
